export default "__VITE_ASSET__uMgsvpAS__"